<mat-stepper MatScrollDirective [stepper]="stepper" class="pt-10" [linear]="true"
  [orientation]="currentScreenSize == 'Small' || currentScreenSize == 'XSmall'? 'vertical' : 'horizontal'" #stepper
  (selectionChange)="onStepChange($event)" (selectedIndexChange)="onSelectedIndexChange($event)">
  <mat-step [editable]="!isConfirmationStepActive" [label]="'PARKIFLY.STEPPER.CHOOSE_PARKING' | transloco"
    [completed]="isParkingSelected">
    <app-parking (parkingPickedEvent)="next()"></app-parking>
  </mat-step>
  @if(isadditionalServicesEnabled) {
  <mat-step [editable]="!isConfirmationStepActive" [label]="'PARKIFLY.STEPPER.ADDITIONAL_SERVICES' | transloco"
    [completed]="true">
    <app-step-additional-services [stepper]="stepper"></app-step-additional-services>
  </mat-step>
  }
  <mat-step [editable]="!isConfirmationStepActive" [label]="'PARKIFLY.STEPPER.YOUR_DETAILS' | transloco"
    [stepControl]="detailsGroup && paymentGroup">
    <app-details [stepper]="stepper"></app-details>
  </mat-step>
  <mat-step [editable]="isPaymentStepActive" [label]="'PARKIFLY.STEPPER.PAYMENT' | transloco"
    [stepControl]="confirmGroup">
    <app-payment [stepper]="stepper" [orderId]="orderId"></app-payment>
  </mat-step>
</mat-stepper>